import {HEADER_HEIGHT_MOBILE} from 'components/Layouts/mobileStyles'

import {COMPACT_HEADER_TOP_HEIGHT} from '@daedalus/atlas/Header'
import {useBrand} from '@daedalus/core/src/_web/brand/hooks/useBrand'
import {CUSTOM_HEADER_HEIGHT} from '@daedalus/shared/src/whiteLabel/CustomHeader'

export const useTopHeaderHeight = (isMobile = false) => {
  const {brandHasCustomHeader} = useBrand()

  if (brandHasCustomHeader) return CUSTOM_HEADER_HEIGHT

  if (isMobile) return HEADER_HEIGHT_MOBILE

  return COMPACT_HEADER_TOP_HEIGHT
}
